import React, { useEffect, useState } from "react";
import MainBg from "../../components/Mainbg";
import { ResponsiveContainer, LineChart, Line } from "recharts";
import secureLocalStorage from "react-secure-storage";
import { useLocation } from "react-router-dom";
import health_active from "../../assets/healthtrack/health_active.png";
import health_bmi from "../../assets/healthtrack/health_bmi.png";
import health_heart_rate from "../../assets/healthtrack/health_heart_rate.png";
import bp_track from "../../assets/healthtrack/bp_track.png";
import health_rest from "../../assets/healthtrack/health_rest.png";
import health_walk from "../../assets/healthtrack/health_walk.png";
import health_weight from "../../assets/healthtrack/health_weight.png";

const linedata_demo = [
  {
    Calorie: 0,
  },
  {
    Calorie: 720,
  },
];
const HealthTrackDetails = ({ weekStart = "Sunday" }) => {
  const accessToken = secureLocalStorage.getItem("accessToken");
  const location = useLocation();
  const [pageSection, setPageSection] = useState(location?.state?.option);
  const [linedata, setLineData] = useState(linedata_demo);

  // Function to get the current week with dates and day names
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <MainBg>
      <div className="container mx-auto p-4 py-2">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {pageSection === "pulse" ? (
            <>
              <div>
                <div className="">
                  <div className="grid grid-cols-1 xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-5 px-0">
                    {/* Heart rate box  */}
                    <div className="w-full bg-white shadow-lg p-2 px-4 rounded-xl">
                      <div className="flex border-b border-[#ddd] border-dotted justify-between">
                        <div className="flex gap-2 items-center ">
                          <div className="">
                            <img src={health_heart_rate} alt="Heart rate" />
                          </div>
                          <div className="mb-1 ">
                            <h1 className="font-medium text-sm">Pulse rate</h1>
                            <p className="text-xs text-[gray]">Summary</p>
                          </div>
                        </div>
                        <div className="mb-1 ">
                          <h1 className="font-medium text-sm text-[#FE7701]">
                            83 bpm
                          </h1>
                          <p className="text-xs text-[gray]">Average</p>
                        </div>
                      </div>
                      <div className="flex mt-3 justify-center">
                        <div className="flex gap-5 items-center justify-evenly">
                          <div className="mb-1 text-center ">
                            <p className="text-xs text-[gray]">Lowest</p>
                            <h1 className="font-medium text-sm">65 bpm</h1>
                          </div>
                          <div className="mb-1 text-center ">
                            <p className="text-xs text-[gray]">Highest</p>
                            <h1 className="font-medium text-sm">65 bpm</h1>
                          </div>
                          <div className="mb-1 text-center ">
                            <p className="text-xs text-[gray]">Sleeping</p>
                            <h1 className="font-medium text-sm">65 bpm</h1>
                          </div>
                          <div className="mb-1 text-center ">
                            <p className="text-xs text-[gray]">Resting</p>
                            <h1 className="font-medium text-sm">65 bpm</h1>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* B.P. Box  */}
                    <div className="w-full bg-white shadow-lg p-2 px-4 rounded-xl">
                      <div className="flex border-b border-[#ddd] border-dotted justify-between">
                        <div className="flex gap-2 items-center ">
                          <div className="">
                            <img src={bp_track} alt="BP track" />
                          </div>
                          <div className="mb-1 ">
                            <h1 className="font-medium text-sm">B.P.</h1>
                            <p className="text-xs text-[gray]">Summary</p>
                          </div>
                        </div>
                        <div className="mb-1 ">
                          <h1 className="font-medium text-sm text-[#FE7701]">
                            120/80
                          </h1>
                          <p className="text-xs text-[gray]">at 3.30pm GST</p>
                        </div>
                      </div>
                      <div className="flex mt-3 justify-center">
                        <div className="flex gap-5 items-center justify-evenly">
                          <div className="mb-1 text-center ">
                            <p className="text-xs text-[gray]">Lowest</p>
                            <h1 className="font-medium text-sm">65 bpm</h1>
                          </div>
                          <div className="mb-1 text-center ">
                            <p className="text-xs text-[gray]">Highest</p>
                            <h1 className="font-medium text-sm">65 bpm</h1>
                          </div>
                          <div className="mb-1 text-center ">
                            <p className="text-xs text-[gray]">Sleeping</p>
                            <h1 className="font-medium text-sm">65 bpm</h1>
                          </div>
                          <div className="mb-1 text-center ">
                            <p className="text-xs text-[gray]">Resting</p>
                            <h1 className="font-medium text-sm">65 bpm</h1>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : pageSection === "weight" ? (
            <>
              <div>
                <div className="">
                  <div className="grid grid-cols-1 xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-5 px-0">
                    {/* Weight box  */}
                    <div className="w-full bg-white shadow-lg p-2 px-4 rounded-xl">
                      <div className="flex border-b border-[#ddd] border-dotted justify-between">
                        <div className="flex gap-2 items-center ">
                          <div className="">
                            <img src={health_weight} alt="Weight" />
                          </div>
                          <div className="mb-1 ">
                            <h1 className="font-medium text-sm">Weight</h1>
                            <p className="text-xs text-[gray]">Summary</p>
                          </div>
                        </div>
                        <div className="mb-1 ">
                          <h1 className="font-medium text-sm text-[#FE7701]">
                            83 bpm
                          </h1>
                          <p className="text-xs text-[gray]">Average</p>
                        </div>
                      </div>
                      <div className="flex mt-3 justify-center">
                        <div className="flex gap-5 items-center justify-evenly">
                          <div className="mb-1 text-center ">
                            <p className="text-xs text-[gray]">Lowest</p>
                            <h1 className="font-medium text-sm">65 bpm</h1>
                          </div>
                          <div className="mb-1 text-center ">
                            <p className="text-xs text-[gray]">Highest</p>
                            <h1 className="font-medium text-sm">65 bpm</h1>
                          </div>
                          <div className="mb-1 text-center ">
                            <p className="text-xs text-[gray]">Sleeping</p>
                            <h1 className="font-medium text-sm">65 bpm</h1>
                          </div>
                          <div className="mb-1 text-center ">
                            <p className="text-xs text-[gray]">Resting</p>
                            <h1 className="font-medium text-sm">65 bpm</h1>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* BMI Box  */}
                    <div className="w-full bg-white shadow-lg p-2 px-4 rounded-xl">
                      <div className="flex border-b border-[#ddd] border-dotted justify-between">
                        <div className="flex gap-2 items-center ">
                          <div className="">
                            <img src={health_bmi} alt="BMI" />
                          </div>
                          <div className="mb-1 ">
                            <h1 className="font-medium text-sm">BMI</h1>
                            <p className="text-xs text-[gray]">Summary</p>
                          </div>
                        </div>
                        <div className="mb-1 ">
                          <h1 className="font-medium text-sm text-[#FE7701]">
                            120/80
                          </h1>
                          <p className="text-xs text-[gray]">at 3.30pm GST</p>
                        </div>
                      </div>
                      <div className="flex mt-3 justify-center">
                        <div className="flex gap-5 items-center justify-evenly">
                          <div className="mb-1 text-center ">
                            <p className="text-xs text-[gray]">Lowest</p>
                            <h1 className="font-medium text-sm">65 bpm</h1>
                          </div>
                          <div className="mb-1 text-center ">
                            <p className="text-xs text-[gray]">Highest</p>
                            <h1 className="font-medium text-sm">65 bpm</h1>
                          </div>
                          <div className="mb-1 text-center ">
                            <p className="text-xs text-[gray]">Sleeping</p>
                            <h1 className="font-medium text-sm">65 bpm</h1>
                          </div>
                          <div className="mb-1 text-center ">
                            <p className="text-xs text-[gray]">Resting</p>
                            <h1 className="font-medium text-sm">65 bpm</h1>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : pageSection === "walk" ? (
            <>
              <div>
                <div className="">
                  <div className="grid grid-cols-1 xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-5 px-0">
                    {/* Weight box  */}
                    <div className="w-full bg-white shadow-lg p-2 px-4 py-6 rounded-xl">
                      <div className="flex justify-between">
                        <div className="flex gap-2 items-center ">
                          <div className="">
                            <img src={health_walk} alt="Walk" />
                          </div>
                          <div className="mb-1 ">
                            <h1 className="font-medium text-sm">Walking</h1>
                            <p className="text-xs text-[gray]">Time spent</p>
                          </div>
                        </div>
                        <div className="mb-1 ">
                          <h1 className="font-medium text-sm text-[#FE7701]">
                            2h 30m
                          </h1>
                          <p className="text-xs text-[gray]">Average</p>
                        </div>
                      </div>
                    </div>

                    {/* BMI Box  */}
                    <div className="w-full bg-white shadow-lg p-2 px-4 py-6 rounded-xl">
                      <div className="flex justify-between">
                        <div className="flex gap-2 items-center ">
                          <div className="">
                            <img src={health_active} alt="Energy" />
                          </div>
                          <div className="mb-1 ">
                            <h1 className="font-medium text-sm">BMI</h1>
                            <p className="text-xs text-[gray]">Energy</p>
                          </div>
                        </div>
                        <div className="mb-1 ">
                          <h1 className="font-medium text-sm text-[#FE7701]">
                            24.5 kcal
                          </h1>
                          <p className="text-xs text-[gray]">Average</p>
                        </div>
                      </div>
                    </div>

                    {/* Resting Box  */}
                    <div className="w-full bg-white shadow-lg p-2 px-4 py-6 rounded-xl">
                      <div className="flex justify-between">
                        <div className="flex gap-2 items-center ">
                          <div className="">
                            <img src={health_rest} alt="resting" />
                          </div>
                          <div className="mb-1 ">
                            <h1 className="font-medium text-sm">Resting</h1>
                            <p className="text-xs text-[gray]">Energy</p>
                          </div>
                        </div>
                        <div className="mb-1 ">
                          <h1 className="font-medium text-sm text-[#FE7701]">
                            1,541 kcal
                          </h1>
                          <p className="text-xs text-[gray]">Average</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>Not found</>
          )}
          {/* Line graph right section */}
          <div className="px-20">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart width={300} height={100} data={linedata}>
                <defs>
                  <radialGradient
                    id="radialGradient"
                    cx="50%"
                    cy="50%"
                    r="50%"
                    fx="50%"
                    fy="50%"
                  >
                    <stop offset="20%" stopColor="rgba(115,80,255,1)" />
                    <stop offset="100%" stopColor="rgba(255,153,80,1)" />
                  </radialGradient>
                </defs>
                <Line
                  type="monotone"
                  dataKey="Calorie"
                  stroke="url(#radialGradient)" // Use the radial gradient here
                  strokeWidth={5}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </MainBg>
  );
};

export default React.memo(HealthTrackDetails);
